import { create } from 'zustand'
import { ENVIRONMENTS, getSelectedEnvKey, withEnvParam } from 'src/config/environments'

/**
 * Store for the selected backend environment.
 *
 * The URL query string (?env=<key>) is the single source of truth: it is
 * explicit, shareable, and survives login/logout redirects and a localStorage
 * clear. The store is just initialized from the URL for reactive UI (the
 * selector); switching env rewrites the URL and reloads, so everything
 * (MSAL realm, axios base URL) is re-resolved from the URL on the next load.
 */
export const useEnvironmentStore = create((set) => ({
  // Key of the currently selected environment (resolved from ?env=, default production)
  selectedEnv: getSelectedEnvKey(),

  /**
   * Switch the active backend environment: rewrite ?env= in the URL and reload
   * so MSAL (auth realm) and axios (base URL) re-resolve cleanly.
   * @param {string} envKey - One of the keys in ENVIRONMENTS
   */
  setSelectedEnv: (envKey) => {
    if (!ENVIRONMENTS[envKey]) {
      console.error(`Invalid environment key: ${envKey}`)
      return
    }
    set({ selectedEnv: envKey })
    window.location.href = withEnvParam(window.location.href, envKey)
  },
}))

/**
 * Returns the base URL of the currently selected environment (from ?env=).
 * Used by the axios instance to build request URLs.
 */
export const getBaseUrl = () => {
  return ENVIRONMENTS[getSelectedEnvKey()]?.baseUrl || ENVIRONMENTS.production.baseUrl
}
